import { css } from "@emotion/react";
import { DateTime } from "luxon";
import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import ExportButton from "../shared/ExportButton";
import HistoricalDataMessage from "../shared/HistoricalDataMessage";
import PaidFeatureButton from "../shared/PaidFeatureButton";
import { useAccount } from "../store/account";
import { useAudienceReport } from "../store/audienceReport";

const numberFormat = new Intl.NumberFormat().format;

export default function Audience() {
    const { data: account } = useAccount();
    const { accountID, showID } = useParams();
    //Audience should be an array, but I'm getting an object?
    const { data: audience = {} } = useAudienceReport(showID);

    return (
        <>
            <Helmet>
                <title>Unique Monthly Audience - Podtrac</title>
            </Helmet>
            <h1>Unique Monthly Audience</h1>
            <div style={{ display: "flex" }}>
                <div style={{ flex: 1 }}>
                    Unique audience members who downloaded one or more episodes of this show during
                    the month
                </div>
                <div style={{ textAlign: "right" }}>
                    {account ? (
                        <PaidFeatureButton
                            hasFeature={account.isPaidPlan}
                            dialogContent="Export of this report to an Excel file is a premium feature available in the Grow Your Show Plan."
                        >
                            {({ hasFeature, openModal }) => {
                                return (
                                    <ExportButton
                                        onClick={
                                            hasFeature
                                                ? () =>
                                                      (window.location = `/__/${accountID}/reports/audienceexport/${showID}`)
                                                : openModal
                                        }
                                    />
                                );
                            }}
                        </PaidFeatureButton>
                    ) : null}
                </div>
            </div>
            <HistoricalDataMessage />
            <table className="table">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Global Audience</th>
                        <th>US Audience</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.values(audience).map((row, i) => (
                        <tr key={i}>
                            <td>
                                {DateTime.fromISO(row.requestMonth, { zone: "utc" }).toLocaleString(
                                    { month: "long", year: "numeric" }
                                )}
                            </td>
                            <td
                                css={css`
                                    text-align: right;
                                `}
                            >
                                {numberFormat(row.uniqueListeners)}
                            </td>
                            <td
                                css={css`
                                    text-align: right;
                                `}
                            >
                                {numberFormat(row.usUniqueListeners)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}
